import React from 'react';
import styled from 'styled-components';

import useTranslation from 'src/hooks/use-translation';
import { GoogleLogin, AppleLogin } from 'src/components/social-login';
import { Divider } from 'src/components/divider';

import {
  CheckoutSection,
  CheckoutLabel,
  CheckoutLabelGrouping,
  CheckoutBody,
  CheckoutSectionHeading,
} from 'src/checkout/components/styles/common';

export function InlineSocialLogin(): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <CheckoutSectionContainer noBorder>
        <CheckoutLabelGrouping id='user-account'>
          <CheckoutLabel>
            <CheckoutSectionHeading>{t('user.account', 'Account')}</CheckoutSectionHeading>
          </CheckoutLabel>
          <CheckoutBody>
            <BodyContentContainer>
              <SocialLogins>
                <GoogleLogin redirectUrl={window.location.href} />
                <AppleLogin redirectUrl={window.location.href} />
              </SocialLogins>
              <Divider text={t('common.or', 'or checkout as a guest')} />
            </BodyContentContainer>
          </CheckoutBody>
        </CheckoutLabelGrouping>
      </CheckoutSectionContainer>
    </>
  );
}

const BodyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 390px;
`;

const SocialLogins = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CheckoutSectionContainer = styled(CheckoutSection)`
  margin-bottom: -29px;
  padding-bottom: 0;
`;
